import * as uuid from "uuid";

const byteToHex: string[] = [];

for (let i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).slice(1));
}

export function unsafeStringify(arr: Record<number, number>, offset = 0) {
    return (byteToHex[arr[offset + 0]] +
        byteToHex[arr[offset + 1]] +
        byteToHex[arr[offset + 2]] +
        byteToHex[arr[offset + 3]] +
        '-' +
        byteToHex[arr[offset + 4]] +
        byteToHex[arr[offset + 5]] +
        '-' +
        byteToHex[arr[offset + 6]] +
        byteToHex[arr[offset + 7]] +
        '-' +
        byteToHex[arr[offset + 8]] +
        byteToHex[arr[offset + 9]] +
        '-' +
        byteToHex[arr[offset + 10]] +
        byteToHex[arr[offset + 11]] +
        byteToHex[arr[offset + 12]] +
        byteToHex[arr[offset + 13]] +
        byteToHex[arr[offset + 14]] +
        byteToHex[arr[offset + 15]]).toLowerCase();
}

export function randomUuid() {
    return uuid.v4();
}

export function idToUuid(id: string) {
    const start = 'beefbeef-beef-beef';
    const middle = id.slice(0, 4);
    const end = id.slice(4);

    return start + '-' + middle + '-' + end;
}

export function uuidToId(uuid: string) {
    const start = uuid.slice(19, 23).toLowerCase();
    const end = uuid.slice(24).toLowerCase();

    return start + end;
}
